import React, { useEffect, useState } from 'react';
import { AjustesCostosExpatriadosSidebarScreen } from './screen';
import { UsuariosAdapter } from '../../../../../../infraestructure/persistence/rest/UsuariosAdapter';
import { useNotifications } from '../../../../../../shared/hooks/Notifications';
import { ServerErrorMessage } from '../../../../../../shared/utils/error';

export const SidebarAjustesCostosExpatriados = (props:any)=>{

    const api = new UsuariosAdapter();
    const { exceptionError, resultError } = useNotifications();
    let result: any;

    const [data,setData] = useState<any>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    useEffect(()=>{if(data.length>0){setData([...[]])}},[props.filter])

    const getExpatriados = async(filter:any) =>{
        setIsLoading(true);
        try {
            result = await api.ListarUsuariosExpatriadosAjustes(filter);
            if(result.data && result.data!=="")
            {
              setData([...result.data]);
              setIsLoading(false);
            }else{resultError();setIsLoading(false);}
          } catch (error) {
            let exception = ServerErrorMessage(error);
            exceptionError(exception)
            setIsLoading(false);
          }
    }
    
    return <AjustesCostosExpatriadosSidebarScreen 
    data={data}
    handleFilter={getExpatriados}
    isLoading={isLoading}
    {...props}/>
}